//-----------------------------------------------------------------------
// <copyright file="login.component.ts" company="LGT India">
//     Author: vanaraj
//     Copyright (c) LGT India. All rights reserved.
// </copyright>
//-----------------------------------------------------------------------
import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { MsalService } from "@azure/msal-angular";
import { CookieService } from "ngx-cookie-service";
import { AppComponent } from "../app.component";
import { AzureAdDemoService } from "../azureAd/azure-ad-demo.service";

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.css"],
})
export class LoginComponent implements OnInit {
  title = "LGT india";
  submit = false;
  loading = false;
  constructor(
    private authService: MsalService,
    private azureAdDemoService: AzureAdDemoService,
    public app: AppComponent,
    private router: Router
  ) {}
  ngOnInit(): void {
    // Perform any initialization tasks here if needed
  }
}
